import { routerRef } from "@/router/routerRef";

/** @deprecated use useRouteParam() or useRouteQuery() instead */
export function getUrlParamAsString(paramName: string): string {
  const route = routerRef!.currentRoute.value;
  const value = route.params[paramName];

  if (value === undefined) {
    throw new Error("Parameter '" + paramName + "' not found in URL.");
  }

  if (typeof value !== "string") {
    throw new Error("Parameter '" + paramName + "' is not a string.");
  }

  return value;
}

/** @deprecated use useRouteParam() or useRouteQuery() instead */
export function getUrlQueryAsString(paramName: string): string {
  const route = routerRef!.currentRoute.value;
  const value = route.query[paramName];

  if (value === undefined) {
    throw new Error("Query parameter '" + paramName + "' not found in URL.");
  }

  if (typeof value !== "string") {
    throw new Error("Query parameter '" + paramName + "' is not a string.");
  }

  return value;
}

/** @deprecated use useRouteParam() or useRouteQuery() instead */
export function getUrlQueryAsNumber(paramName: string): number {
  const route = routerRef!.currentRoute.value;
  const value = route.query[paramName];

  if (value === undefined) {
    throw new Error("Parameter '" + paramName + "' not found in URL.");
  }

  if (typeof value !== "string") {
    throw new Error("DEV: Parameter '" + paramName + "' is not a string.");
  }

  if (isNaN(+value)) {
    throw new Error("Parameter '" + paramName + "' is not a number.");
  }

  return +value;
}

/**
 * @deprecated use useRouteParam() or useRouteQuery() instead
 * @todo Rename to getUrlQuery...(). It's not working with params, it's working with query!
 */
export function getUrlParamAsBool(paramName: string, allowZeroAndOne = false): boolean {
  const route = routerRef!.currentRoute.value;
  const value = route.query[paramName];

  if (value === undefined) {
    throw new Error("Parameter '" + paramName + "' not found in URL.");
  }

  if (typeof value !== "string") {
    throw new Error("DEV: Parameter '" + paramName + "' is not a string.");
  }

  if (value === "true") {
    return true;
  } else if (value === "false") {
    return false;
  }

  if (allowZeroAndOne) {
    if (value === "1") {
      return true;
    } else if (value === "0") {
      return false;
    }
  }

  throw new Error("URL parameter '" + paramName + "' has invalid value.");
}
